export default "__VITE_ASSET__d7f5b514__"